import { getAllTimezones as countriesGetAllTimezones } from 'countries-and-timezones';

export const getBrowserTimezone = () =>
  // eslint-disable-next-line new-cap -- Library definition
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getBrowserTimezoneWithOffset = () => {
  const timeZone = getBrowserTimezone();
  const offsetParts = new Intl.DateTimeFormat(undefined, {
    timeZone,
    timeZoneName: 'longOffset',
  }).formatToParts(new Date());
  const offset = offsetParts.find((part) => part.type === 'timeZoneName')?.value ?? '';
  return { offset, timeZone };
};

export const getCurrentUserTimezone = () => {
  let currentUserTimezone = getBrowserTimezone();

  const allTimezones = Object.values(getAllTimezones());
  const isTimezonePresent = allTimezones.some((timeZoneObject) => timeZoneObject.value === currentUserTimezone);

  if (!isTimezonePresent) {
    currentUserTimezone = 'America/Chicago';
  }

  return currentUserTimezone;
};

const getAllTimezones = () => {
  const america: Array<{ label: string; utcOffset: number; value: string }> = [];
  const rest: Array<{ label: string; utcOffset: number; value: string }> = [];

  for (const timezone of Object.values(countriesGetAllTimezones({ deprecated: true }))) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    if (timezone.countries?.length > 0) {
      const country = {
        label: `(GMT${timezone.utcOffsetStr}) ${timezone.name}`,
        utcOffset: timezone.utcOffset,
        value: timezone.name,
      };

      if (country.value.startsWith('America/')) {
        america.push(country);
      } else {
        rest.push(country);
      }
    }
  }

  const sortedAmerica = america.toSorted((a, b) => a.utcOffset - b.utcOffset);
  const sortedRest = rest.toSorted((a, b) => a.utcOffset - b.utcOffset);

  return [...sortedAmerica, ...sortedRest];
};

export const timezones = getAllTimezones();
